import styled from "styled-components";

const StyledContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default StyledContent;
